import { useMemo } from 'react';
import moment from 'moment';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { useGetAppointmentSlotList } from 'src/hooks/frontdesk';

const AppointmentSlotCalendarView = () => {
  const { data, isError } = useGetAppointmentSlotList();
  const slots = data?.appointmentSlotList || [];

  // Convert appointment slots to FullCalendar events
  const calendarEvents = useMemo(
    () =>
      slots.map((slot) => {
        const startDateTime = moment(
          `${slot.date} ${slot.start_time}`,
          'YYYY-MM-DD HH:mm'
        ).toISOString();
        const endDateTime = moment(
          `${slot.date} ${slot.end_time}`,
          'YYYY-MM-DD HH:mm'
        ).toISOString();

        let backgroundColor = '#d1d5db'; // default gray
        let borderColor = '#9ca3af';
        let textColor = '#374151';

        if (slot.status === 'Available') {
          backgroundColor = '#10b981'; // green
          borderColor = '#059669';
          textColor = '#ffffff';
        } else if (slot.status === 'Booked') {
          backgroundColor = '#3b82f6'; // blue
          borderColor = '#2563eb';
          textColor = '#ffffff';
        } else if (slot.status === 'Blocked') {
          backgroundColor = '#ef4444'; // red
          borderColor = '#dc2626';
          textColor = '#ffffff';
        }

        return {
          id: slot.id,
          title: `${slot.provider_name} - ${slot.status}`,
          start: startDateTime,
          end: endDateTime,
          backgroundColor,
          borderColor,
          textColor,
          extendedProps: {
            ...slot,
          },
        };
      }),
    [slots]
  );

  const handleEventClick = (clickInfo: any) => {
    const slot = clickInfo.event.extendedProps;
    // You can add a modal or tooltip here to show more details
    console.log('Clicked slot:', slot);
  };

  if (isError) {
    return (
      <div className="flex justify-center items-center p-8">
        <div className="text-red-500 text-lg">
          Error loading appointment slots
        </div>
      </div>
    );
  }

  return (
    <div className="h-full">
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay',
        }}
        initialView="timeGridWeek"
        height="auto"
        events={calendarEvents}
        eventClick={handleEventClick}
        slotMinTime="07:00:00"
        slotMaxTime="19:00:00"
        allDaySlot={false}
        nowIndicator={true}
        eventDisplay="block"
        dayMaxEvents={true}
        moreLinkClick="popover"
        eventTimeFormat={{
          hour: 'numeric',
          minute: '2-digit',
          meridiem: 'short',
        }}
        slotLabelFormat={{
          hour: 'numeric',
          minute: '2-digit',
          meridiem: 'short',
        }}
        eventContent={(eventInfo) => (
          <div className="p-1 text-xs">
            <div className="font-medium truncate">
              {eventInfo.event.extendedProps.provider_name}
            </div>
            <div className="truncate">
              {eventInfo.event.extendedProps.status}
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default AppointmentSlotCalendarView;
